import type { FaireThemeEntity } from "../../entity_types/theme";

export const shell_coastal_keepsake_d_cor: FaireThemeEntity = {
  token: "shell-coastal-keepsake-d-cor",
  type: "theme",
  retailerToken: "r_bvuv8mj0x6",
  name: "Shell + Coastal Keepsake D\u00e9cor",
  description: "Coastal keepsakes visitors take home as island memories",
  bgColor: "#F5E6C8",
  tileBgColor: "#7e5733",
  productTokens: [
    "p_egt7frp2w7",
    "p_s5yvtd4qmv",
    "p_5wxg72vddw",
    "p_3ew4chqt95",
  ],
  exactProducts: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:50:10Z",
    importedBy: "retailer-themes-entity-migration",
  },
};
